export const INIT_GLOBAL_ROUTER_CONFIG = 'INIT_GLOBAL_ROUTER_CONFIG' // 初始化全局路由配置
export const UPDATE_CURR_ROUTE = 'UPDATE_CURR_ROUTE' // 更新当前路由信息
export const UPDATE_CURR_PAGE = 'UPDATE_CURR_PAGE' // 更新当前页面信息